import { Pipe, PipeTransform } from "@angular/core";

import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";
@Pipe({
  name: "viewdays",
})
export class ViewdaysPipe implements PipeTransform {
  encrypted_data: any;

  transform(value: any, currentDate: any): any {
    if (localStorage.getItem(environment.localStorageKey)) {
      this.encrypted_data = localStorage.getItem(environment.localStorageKey);
      this.encrypted_data = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encrypted_data,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      if (this.encrypted_data.subscription_date) {
        if (currentDate) {
          var date1: any = new Date(currentDate.replace(/-/g, "/")).getTime();
        } else if (!currentDate) {
          var date1: any = new Date();
        }
        var date2: any = new Date(
          this.encrypted_data.subscription_date.replace(/-/g, "/")
        ).getTime();

        var Difference_In_Time = date1 - date2;

        var Difference_In_Days = Math.floor(
          Difference_In_Time / 1000 / 60 / 60 / 24
        );

        var leftDays = value - Difference_In_Days;

        if (Math.trunc(Difference_In_Days) >= value) {
          var status = {
            isLock: false,
            leftDays: leftDays,
          };
          return status;
        } else {
          var status = {
            isLock: true,
            leftDays: leftDays,
          };
          return status;
        }
      } else {
        return true;
      }
    }
  }
}
